export const LP_WELCOME = {en: "Welcome to SONAX" , tr: "Sonax'a Hoşgeldiniz"};
export const LP_TEXT1 = {en: "MODERN EQUIPMENT", tr: "Modern Ekİpman"};
export const LP_TEXT2 = {en: "Keeping Your Car New", tr: "Arabanızı Temiz Tutun"};
export const LP_BTN_TEXT = {en: "Contact us" , tr: "Bize Ulaşın"};
